import { Pipe, PipeTransform } from '@angular/core';

import { type WorkflowError } from '@blaze-runtime/workflow-domain';

@Pipe({
  name: 'workflowErrorHandler',
})
export class WorkflowErrorHandlerPipe implements PipeTransform {
  transform(errors: WorkflowError<any>[], sourceId: string | undefined): unknown[] {
    return sourceId
      ? errors?.filter((error: WorkflowError<any>) => error.sourceId === sourceId)
      : errors;
  }
}
